import React from 'react';
import { formatPreparationEvidenceCitation } from './preparationSourceAuthors';
import { Box, ButtonBase, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { ChevronRightRounded as ChevronIcon } from '@mui/icons-material';
import LogFormShell from '../../components/UI/LogFormShell';
import colors from '../../assets/theme/colors';

const PreparationReferenceSheet = ({ open, sources = [], accent, onClose, onSelect }) => (
  <LogFormShell open={open} onClose={onClose} title="Sources for this summary" subtitle={`${sources.length} supporting records`}>
    <Stack spacing={0.7} sx={{ p: { xs: 1.5, md: 2 } }}>
      {sources.map((item, index) => (
        <ButtonBase
          key={`${item.sourceType}:${item.sourceId}`}
          onClick={() => onSelect(item)}
          sx={{ width: '100%', p: 1.1, gap: 0.8, justifyContent: 'flex-start', textAlign: 'left', borderRadius: '14px', border: `1px solid ${alpha(accent.primary, 0.2)}` }}
        >
          <Box sx={{ minWidth: 0, flex: 1 }}>
            <Typography sx={{ mb: 0.25, fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.05em', color: alpha(colors.semantic.ink, 0.58) }}>
              Source {index + 1} · {formatPreparationEvidenceCitation(item)}
            </Typography>
            <Typography sx={{ fontSize: '0.9rem', lineHeight: 1.42, color: colors.semantic.ink }}>
              {item.description || item.label}
            </Typography>
          </Box>
          <ChevronIcon sx={{ color: accent.ink }} />
        </ButtonBase>
      ))}
    </Stack>
  </LogFormShell>
);

export default PreparationReferenceSheet;
